export default __webpack_public_path__ + "static/media/EmmalynLoginBanner.a2b2bf94.jpg";